import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { domains } from 'config/env'
import NavigationHelper from 'layers/navigation/navigationHelper'
import { toKebabCase } from 'utils/stringHelpers'
import AdminSearchSelect from 'components/AdminSearchSelect'
import {
  LinkImage,
  StyledOutlineButton,
  SupportLinksWrapper,
} from './component.styles'
import { LICENSE_MANAGEMENT, USER_MANAGEMENT } from './constants'

const AdminResourceLinkList = ({
  availableLinks,
  navigationEvent,
  handleOpenModal,
}) => {
  const navigateHandler = (urlPath, openSameTab) => {
    const type = openSameTab
      ? NavigationHelper.types.PUSH
      : NavigationHelper.types.NEW_TAB_SAME_SITE

    if (
      urlPath.includes(LICENSE_MANAGEMENT) ||
      urlPath.includes(USER_MANAGEMENT)
    ) {
      navigationEvent(
        `${domains.ADMIN_DOMAIN}${urlPath}`,
        NavigationHelper.types.OPEN,
      )
    } else {
      navigationEvent(urlPath, type)
    }
  }

  const renderSupportLinks = () => {
    let links
    if (availableLinks) {
      links = availableLinks.map(link => {
        const { buttonText, displayTitle, icon, linkMenu } = link || {}
        const { file, title } = icon || {}
        const { details, url: imgUrl } = file || {}
        const { image } = details || {}
        const { height, width } = image || {}

        const DropdownButtonIcon = dataTestId => (
          <LinkImage
            alt={title}
            dataTestId={dataTestId}
            height={height}
            key={dataTestId}
            src={imgUrl}
            width={width}
          />
        )

        const handleLinkAction = link => {
          if (link.modalId && handleOpenModal) {
            handleOpenModal(link.modalId)
          } else {
            navigateHandler(link.url, link.openSameTab)
          }
        }
        const handleDropdownChange = option => handleLinkAction(option)

        return (
          <Fragment key={title || buttonText}>
            {linkMenu && (
              <AdminSearchSelect
                dataTestId={toKebabCase(displayTitle)}
                defaultLabel={displayTitle}
                dropdownButtonIcon={<DropdownButtonIcon />}
                keyProp="id"
                labelProp="buttonText"
                onChange={handleDropdownChange}
                options={linkMenu}
                shouldHideSelectedIcon={true}
              />
            )}

            {!linkMenu && (
              <StyledOutlineButton
                dataTestId={toKebabCase(buttonText)}
                onClick={() => handleLinkAction(link)}
              >
                <LinkImage
                  alt={title}
                  height={height}
                  src={imgUrl}
                  width={width}
                />
                {buttonText}
              </StyledOutlineButton>
            )}
          </Fragment>
        )
      })
    }
    return links
  }

  return <SupportLinksWrapper>{renderSupportLinks()}</SupportLinksWrapper>
}

AdminResourceLinkList.propTypes = {
  availableLinks: PropTypes.array,
  handleOpenModal: PropTypes.func,
  navigationEvent: PropTypes.func,
}

export default AdminResourceLinkList
